import { apiClient } from './api/client';
import { Product, CreateProductDto, UpdateProductDto } from '@/types/product.types';

export const productService = {
  async getAll(): Promise<Product[]> {
    return await apiClient.get<Product[]>('/products');
  },

  async getById(id: number): Promise<Product> {
    return await apiClient.get<Product>(`/products/${id}`);
  },

  async create(data: CreateProductDto): Promise<Product> {
    return await apiClient.post<Product>('/products', data);
  },

  async update(id: number, data: UpdateProductDto): Promise<Product> {
    return await apiClient.put<Product>(`/products/${id}`, data);
  },

  async delete(id: number): Promise<void> {
    return await apiClient.delete(`/products/${id}`);
  },
};

